import { render, staticRenderFns } from "./OccasionFilter.vue?vue&type=template&id=ec9c24fe&scoped=true&"
import script from "./OccasionFilter.vue?vue&type=script&lang=js&"
export * from "./OccasionFilter.vue?vue&type=script&lang=js&"
import style0 from "./OccasionFilter.vue?vue&type=style&index=0&id=ec9c24fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9c24fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec9c24fe')) {
      api.createRecord('ec9c24fe', component.options)
    } else {
      api.reload('ec9c24fe', component.options)
    }
    module.hot.accept("./OccasionFilter.vue?vue&type=template&id=ec9c24fe&scoped=true&", function () {
      api.rerender('ec9c24fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Filters/OccasionFilter.vue"
export default component.exports